/** The world's simplest util: takes a function and runs it.
 * Provides a more readable alternative to the "immediately-instantiated function expression",
 * where you can tell straight away that the function is getting run, instead of having to read
 * down to the end.
 */

export const run = <T>(it: () => T): T => it();
